<template>
<div id="header" class="load">

<!-- 
  <div class="topMenu">
<div class="leftside">
  <img src="/static/images/common/logo_damda.png" alt="담다" class="logo logoWhite">
  <img src="/static/images/common/DAMDA_logo.png" alt="담다" class="logo logoColor">
  <nav class="menu-box-1">
    <ul class = "navbar-nav">
      <li class = "nav-item"><a class="nav-link dropdown-toggle" href="javascript:" @click="navbar_onoff()">DAMDA</a>
        <ul class="dropdown-menu" id = "dropdown-menu">
          <li><router-link to="/about/bigdataflatform" >빅데이터 플랫폼</router-link></li>
          <li><router-link to="/about/services" >지원서비스</router-link></li>
        </ul>
      </li>
    </ul>
    <ul class = "navbar-nav">
      <li class = "nav-item"><a class="nav-link dropdown-toggle" href="javascript:" @click="navbar_onoff()">기업협의회</a>
        <ul class="dropdown-menu" id = "dropdown-menu">
          <li><router-link to="/partner" >기업협의회 소개</router-link></li>
          <li><router-link to="/partner" >기업협의회 가입신청</router-link></li>
        </ul>
      </li>
    </ul>
    <ul class = "navbar-nav">
      <li class = "nav-item"><a class="nav-link dropdown-toggle" href="javascript:" @click="navbar_onoff()">다운로드</a>
        <ul class="dropdown-menu" id = "dropdown-menu">
          <li><router-link to="/download/sdk" >SDK 다운로드</router-link></li>
          <li><router-link to="/download/template" >모바일 템플릿앱 다운로드</router-link></li>
          <li><router-link to="/download/Vue" >자료실</router-link></li>
        </ul>
      </li>
    </ul>
    
      <li class = "nav-item"><a class="nav-link dropdown-toggle" href="javascript:" @click="navbar_onoff()">고객센터</a>
        <ul class="dropdown-menu" id = "dropdown-menu">
          <li><router-link to="/support/notice" >공지사항</router-link></li>
          <li><router-link to="/support/faq" >자주 묻는 질문</router-link></li>
          <li><router-link to="/support/qna" >고객문의</router-link></li>
        </ul>
      </li>
  </nav>
</div>
    </div>

    <div class="topMenu rightside">
        <a href="/web/main" class="to_login" v-if="!isAuthenticated">로그인</a>
        <router-link to="/member/regist" class="to_joinin" v-if="!isAuthenticated">회원가입</router-link>
        <router-link to="/partner#apply" class="to_request">기업협의회 가입신청</router-link>
        <a href="javascript:" class="noborder" v-if="isAuthenticated"><span v-text="userName"></span> 님 환영합니다.</a>
        <a href="javascript:" class="to_joinin" v-if="isAuthenticated" @click="logoutAndRedirect()">로그아웃</a>
        <a href="javascript:" class="portal" v-if="isAuthenticated" @click="checkPortal()">포탈</a>
      </div>

 -->



   <div class="headerTop clearfix">
     <div class="headerTop_left">
      <p></p>
    </div>

    <div class="headerTop_right">
      <a href="/web/main" class="to_login" v-if="!isAuthenticated">로그인</a>
      <router-link to="/member/regist" class="to_joinin" v-if="!isAuthenticated">회원가입</router-link>
      <a href="javascript:" class="noborder" v-if="isAuthenticated"><span v-text="userName"></span> 님 환영합니다.</a>
      <a href="javascript:" class="to_joinin" v-if="isAuthenticated" @click="logoutAndRedirect()">로그아웃</a>
      <router-link to="/partner#apply" class="to_request">기업협의회 가입신청</router-link>
      <a href="javascript:" class="portal" @click="checkPortal()">포탈</a>
    </div>
   </div>
   <div class="headerBot">
     <h1>
       <a href="/" class="logo"><img src="/static/images/common/logo_damda.png" alt="담다" class="logo_white"><img src="/static/images/common/DAMDA_logo.png" alt="" class="logo_color"></a>
     </h1>
    <a href="javascript:" class="btn_all_menu">
      <span class="barTop"></span>
      <span class="barMid"></span>
      <span class="barBot"></span>
    </a>

   </div>
    <div class="allMenuWrap winH" style="height: 941px;">
    <div class="allMenuTop">
      <a href="index.html"><img src="/static/images/common/logo_gray.png" alt="" class="logo_menu"></a>
      <a href="" class="close_menu">메뉴 닫기</a>
    </div>
    <div class="allMenuWrap_inner">
      <div class="allMenu_inner">

        <ul class="allMenu clearfix">
          <li class="hasDep2">
            <a href="">DAMDA 소개</a>
            <ul class="dep2">
              <li ><router-link to="/about/bigdataflatform" >빅데이터 플랫폼</router-link></li>
              <li ><router-link to="/about/services" >지원서비스</router-link></li>
            </ul>
          </li>
           <li class="hasDep2">
            <a href="">기업협의회</a>
            <ul class="dep2">
              <li ><router-link to="/partner" >기업협의회 소개</router-link></li>
            </ul>
          </li>
          
          <li class="hasDep2">
            <a href="">다운로드</a>
            <ul class="dep2">
              <li ><router-link to="/download/sdk" >SDK 다운로드</router-link></li>
              <li ><router-link to="/download/template" >모바일 템플릿앱 다운로드</router-link></li>
              <li><router-link to = "/download/Vue" >자료실</router-link></li>
            </ul>
          </li>
          <li class="hasDep2">
            <a href="">이용안내</a>
            <ul class="dep2">
              <li ><router-link to="/support/notice" >공지사항</router-link></li>
              <li ><router-link to="/support/faq" >FAQ</router-link></li>
              <li ><router-link to="/support/qna" >1:1문의</router-link></li>
            </ul>
          </li>
          <li class="hasDep2">
            <a href="">마이페이지</a>
            <ul class="dep2">
              <li><router-link to="/my/info" >회원정보관리</router-link></li>
              <li><router-link to="/my/qna" >1:1문의내역</router-link></li>
            </ul>
          </li>
        </ul>
         <div class="btn_family">
          <a href="/web/main" class="to_login" v-if="!isAuthenticated">로그인</a>
          <router-link to="/member/regist" class="to_joinin" v-if="!isAuthenticated">회원가입</router-link>
          <a href="javascript:" class="loginTxt" v-if="isAuthenticated"><span>{{ userName }}</span> 님 환영합니다.</a>
          <a href="javascript:" class="to_joinin" v-if="isAuthenticated" @click="logoutAndRedirect()">로그아웃</a>
          <router-link to="/partner#apply" class="to_request">기업협의회 가입신청</router-link>
          <a href="javascript:" class="portal" @click="checkPortal()">포탈</a>
        </div>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe"></iframe>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe_portal"></iframe>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe_hura"></iframe>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe_bai"></iframe>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe_ey"></iframe>
      </div>
    </div>
  </div>
  <div class="allMenuWrap_dim winH" style="height: 891px;"></div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'main-header',
  data () {
    return {
    }
  },
  methods: {
    ...mapActions([ 'logout' ]),
    logoutAndRedirect () {
      if (confirm('로그아웃 하시겠습니까?')) {
        document.getElementById('resiframe').src = process.env.LANDING_LOGOUT_URL
        document.getElementById('resiframe_portal').src = process.env.PORTAL_LOGOUT_URL
        document.getElementById('resiframe_hura').src = process.env.HURA_LOGOUT_URL
        // console.log('HURA_LOGOUT_URL', process.env.HURA_LOGOUT_URL)
        // alert(process.env.HURA_LOGOUT_URL)
        var bailogouturl = process.env.BAI_LOGOUT_URL.replace('{{userId}}', this.userId)
        // console.log('BAI_LOGOUT_URL', bailogouturl)
        // alert(bailogouturl)
        document.getElementById('resiframe_bai').src = bailogouturl
        document.getElementById('resiframe_ey').src = process.env.EY_LOGOUT_URL
        this.logout().then(resp => {
          window.location.href = '/'
        })
      }
    },
    checkPortal () {
      if (this.isAuthenticated && this.isCertUser) {
        location.href = process.env.PORTAL_URL
      } else if (this.isAuthenticated && !this.isCertUser) {
        alert('기업협의회에 가입해야 사용 가능합니다.')
      } else {
        alert('로그인 후 이용 가능합니다.')
        window.location.href = '/web/main?goto=portal'
      }
    },
    navbar_onoff () {
      var nav_dropdown_menu = document.getElementById('dropdown-menu');
      
      if(nav_dropdown_menu.className == 'dropdown-menu') {
        nav_dropdown_menu.className = 'dropdown-menu show';
      } else if(nav_dropdown_menu.className == 'dropdown-menu show'){
        nav_dropdown_menu.className = 'dropdown-menu';
      }
    }
  },
  computed: {
    ...mapState({
      userName: state => state.auth.userInfo.name,
      isAuthenticated: state => state.auth.userInfo,
      isCertUser: state => state.auth.userInfo.org_cd,
      userId: state => state.auth.userInfo.user_id
    })
  },
  mounted () {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.allMenuWrap .btn_family a.portal, #header .headerTop_right a.portal {
  color: #4385f5;
  border: 1px solid #4385f5;
}
#header .headerTop a.noborder {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/include/MainHeader.vue